import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { PAYMENT_STATUSES } from '_constants/billing';
import { theme } from '_constants/theme';

const Container = styled.div`
  min-width: 10px;
  max-width: 10px;
  min-height: 10px;
  max-height: 10px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
`;

const Indicator = ({ status, ...otherProps }) => {
  let title = '';
  let color = '';

  switch (status) {
    case PAYMENT_STATUSES.Success:
      color = theme.colors.green.primary;
      title = 'Paid';
      break;

    case PAYMENT_STATUSES.FullRefund:
      color = theme.colors.orange.primary;
      title = 'Full Refunded';
      break;

    case PAYMENT_STATUSES.PartialRefund:
      color = theme.colors.yellow.primary;
      title = 'Partial Refunded';
      break;

    case PAYMENT_STATUSES.Chargeback:
      color = theme.colors.red.primary;
      title = 'Charged Back';
      break;

    case PAYMENT_STATUSES.Declined:
      color = theme.colors.red.primary;
      title = 'Open';
      break;

    case PAYMENT_STATUSES.Failed:
      color = theme.colors.red.primary;
      title = 'Failed';
      break;

    case 'Completed':
    case 'Active':
    case 'ACTIVE':
      color = theme.colors.green.primary;
      title = 'Active';
      break;

    case 'RECYCLE_FAILED':
      color = theme.colors.yellow.primary;
      title = 'Card Declined';
      break;

    case 'Lead':
    case 'Error':
    case 'Processing':
      color = theme.colors.cyanBlue;
      title = 'Processing';
      break;

    case 'Cancelled':
    case 'CANCELLED':
      color = theme.colors.red.primary;
      title = 'Cancelled';
      break;

    default:
      color = status ? theme.colors.green.primary : theme.colors.red.primary;
      title = status ? 'Active' : 'Not Active';
      break;
  }

  return <Container status={status} title={title} color={color} {...otherProps} />;
};

Indicator.propTypes = {
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default Indicator;
